import axios from 'axios';

export const getAddressByCep = async (cep) => {
  if (!cep) return null;
  const cleanCep = String(cep).replace(/\D/g, '');
  if (cleanCep.length < 8) return null;

  try {
    const response = await axios.get(`https://api.unicamp.br/fe-dac/v1/ceps/${cleanCep}`);
    if (response.data && !response.data.erro) {
      return response.data;
    }
  } catch (error) {
    console.error('Erro ao consultar CEP:', error);
  }
  return null;
};